import { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { ConfigProvider, App as AntApp, theme as antdTheme } from 'antd';
import routes from './config/routes';
import useUserStore from './store/userStore';
import useThemeStore from './store/themeStore';
import FeatureProvider from './components/FeatureProvider';
import FeedbackPopup from './components/FeedbackPopup/FeedbackPopup';
import BetaWelcomeModal from './components/BetaWelcomeModal';
import usePageTracking from './hooks/usePageTracking';
import './styles/index.css';

const AppRoutes = () => {
  usePageTracking();
  const element = useRoutes(routes);
  return element;
};

const App = () => {
  const fetchUser = useUserStore((state) => state.fetchUser);
  const darkMode = useThemeStore((state) => state.darkMode);

  // Fetch user info khi app mount (nếu có token)
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  // Đồng bộ class dark vào document root
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('tw-dark', darkMode);
    root.style.colorScheme = darkMode ? 'dark' : 'light';
  }, [darkMode]);

  const themeConfig = useMemo(
    () => ({
      algorithm: darkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
      token: {
        colorPrimary: '#6FFFB8',
        colorLink: '#6FFFB8',
        colorBgBase: darkMode ? '#0A1A2F' : '#ffffff',
        colorTextBase: darkMode ? '#f8fafc' : '#0f172a',
      },
    }),
    [darkMode],
  );

  return (
    <ConfigProvider theme={themeConfig}>
      <AntApp>
        <FeatureProvider>
          <Router>
            <AppRoutes />
            <FeedbackPopup />
            <BetaWelcomeModal />
          </Router>
        </FeatureProvider>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
